import type { CampanhaStatus } from 'service/api'
import { match } from 'ts-pattern'

export function rotuloStatus(status: CampanhaStatus) {
    return match(status)
        .with('agendada', () => 'Agendada')
        .with('ativa', () => 'Ativa')
        .with('enviada', () => 'Enviada')
        .with('encerrada', () => 'Encerrada')
        .exhaustive()
}

export function corStatus(status: CampanhaStatus) {
    return match(status)
        .with('agendada', () => 'warning' as const)
        .with('ativa', () => 'success' as const)
        .with('enviada', () => 'info' as const)
        .with('encerrada', () => 'error' as const)
        .exhaustive()
}
